module.exports = "/assets/images/holidays.jpg?56ba6ec87b31473652c3374bf15e90a8";